import { freeEmailProviderDomains } from '../free-email-provider-domains'

export const textTruncate = (text: string, num: number): string => {
  if (!text) return ''
  if (num >= text.length) return text
  let result = ''
  const words = text.split(' ')

  let i = 0
  while (i < words.length) {
    if (result.length + words[i].length + 1 > num) {
      break
    } else {
      result += ` ${words[i]}`
    }
    i++
  }
  if (result[result.length - 1] === '.') {
    result += '..'
  } else {
    result += '...'
  }
  return result
}

export const checkValidEmail = (email: string): boolean => {
  if (!email.includes('@')) return false
  const [, domain] = email.split('@')
  if (freeEmailProviderDomains.includes(domain)) return false
  return true
}

export const getCookie = (name: string): string | null => {
  const re = new RegExp(name + "=([^;]+)")
  let value = null
  if (typeof window !== "undefined") {
    value = re.exec(document.cookie)
  }
  return value != null ? unescape(value[1]) : null
}
